import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ModalWizard from "../../../components/modal/ModalWizard";
import ToCompanyStockWizard from "./components/ToCompanyStockWizard";
import TagsService from "../../../services/Tags/TagsService";
import StockService from "../../../services/Stock/StockService";
import { toast } from "react-toastify";
import RouteCreator from "../../../core/RouteCreator";

const ScreeWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    display: flex;
    flex-wrap: nowrap;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
`;

const ToCompanyStock = () => {
    const { t } = useTranslation("screens");
    const history = useHistory();

    const queryCylinderTags = async (tag) => {
        if (tag.length > 2) {
            const tags = await TagsService.lookupExistingCylinderTags(tag);
            return tags.map((t) => t.id);
        }
        return [];
    };

    useEffect(() => {
        ModalWizard.show(
            ToCompanyStockWizard(t, queryCylinderTags),
            {
                onSubmit: async (values) => {
                    const result = await StockService.moveToCompanyStockAsync(
                        values.cylinderTagId
                    );

                    if (result && result.error)
                        ModalWizard.submitFailed(t(result.error.message));
                    else {
                        toast.success(
                            t("installerStockListing.toastNotification.success")
                        );
                        ModalWizard.hide();
                        setTimeout(() => {
                            history.push(RouteCreator.pwa.stock());
                        }, 100);
                    }
                },
                onCancel: async () => {
                    ModalWizard.hidePrompt(()=>history.goBack());
                },
            },
            { pwa: true }
        );
    }, []);

    return <ScreeWrapper></ScreeWrapper>;
};

export default ToCompanyStock;
